"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSurveyDataList = exports.isCancellationSurveyResponse = exports.CancellationSurveyReasonMap = exports.CancellationSurveyReasonOther = exports.CancellationSurveyReasonWithoutOther = void 0;
const z = __importStar(require("zod"));
const type_validation_helpers_1 = require("../helpers/type_validation_helpers");
const language_codes_types_1 = require("./language_codes_types");
var CancellationSurveyReasonWithoutOther;
(function (CancellationSurveyReasonWithoutOther) {
    CancellationSurveyReasonWithoutOther[CancellationSurveyReasonWithoutOther["MET_MY_GOALS"] = 1] = "MET_MY_GOALS";
    CancellationSurveyReasonWithoutOther[CancellationSurveyReasonWithoutOther["NOT_MEETING_MY_GOALS"] = 2] = "NOT_MEETING_MY_GOALS";
    CancellationSurveyReasonWithoutOther[CancellationSurveyReasonWithoutOther["FOUND_DIFFERENT_WAY"] = 3] = "FOUND_DIFFERENT_WAY";
    CancellationSurveyReasonWithoutOther[CancellationSurveyReasonWithoutOther["DONT_UNDERSTAND_METHOD"] = 4] = "DONT_UNDERSTAND_METHOD";
    CancellationSurveyReasonWithoutOther[CancellationSurveyReasonWithoutOther["UNSATISFIED"] = 5] = "UNSATISFIED";
    CancellationSurveyReasonWithoutOther[CancellationSurveyReasonWithoutOther["PRICE_IS_HIGH"] = 6] = "PRICE_IS_HIGH";
})(CancellationSurveyReasonWithoutOther = exports.CancellationSurveyReasonWithoutOther || (exports.CancellationSurveyReasonWithoutOther = {}));
var CancellationSurveyReasonOther;
(function (CancellationSurveyReasonOther) {
    CancellationSurveyReasonOther[CancellationSurveyReasonOther["OTHER"] = 7] = "OTHER";
})(CancellationSurveyReasonOther = exports.CancellationSurveyReasonOther || (exports.CancellationSurveyReasonOther = {}));
exports.CancellationSurveyReasonMap = Object.freeze({
    [CancellationSurveyReasonWithoutOther.MET_MY_GOALS]: "I met my learning goals",
    [CancellationSurveyReasonWithoutOther.NOT_MEETING_MY_GOALS]: "I’m not meeting my learning goals",
    [CancellationSurveyReasonWithoutOther.FOUND_DIFFERENT_WAY]: "I found a different way to meet my learning goals",
    [CancellationSurveyReasonWithoutOther.DONT_UNDERSTAND_METHOD]: "I don’t understand what makes Fluent Forever’s method unique",
    [CancellationSurveyReasonWithoutOther.UNSATISFIED]: "I’m unsatisfied with the quality of the app",
    [CancellationSurveyReasonWithoutOther.PRICE_IS_HIGH]: "The price is too high",
    [CancellationSurveyReasonOther.OTHER]: "Other (please specify)",
});
const CancellationSurveyReasonWithoutOtherSchema = z.nativeEnum(CancellationSurveyReasonWithoutOther);
const CancellationSurveyReasonOtherSchema = z.nativeEnum(CancellationSurveyReasonOther);
const CancellationSurveyResponseWithoutOtherSchema = z.object({
    canFollowUpByEmail: z.boolean(),
    option: CancellationSurveyReasonWithoutOtherSchema,
    suggestions: z.string().optional(),
    userId: z.string(),
});
const CancellationSurveyResponseOtherSchema = z.object({
    canFollowUpByEmail: z.boolean(),
    option: CancellationSurveyReasonOtherSchema,
    otherReason: z.string(),
    suggestions: z.string().optional(),
    userId: z.string(),
});
const CancellationSurveyResponseSchema = z.union([
    CancellationSurveyResponseWithoutOtherSchema,
    CancellationSurveyResponseOtherSchema,
]);
exports.isCancellationSurveyResponse = type_validation_helpers_1.getVerboseTypeValidationFunction(CancellationSurveyResponseSchema);
const SurveySchema = z.object({
    answers: z.string().array(),
    createdAt: z.string(),
    id: z.string(),
    question: z.string(),
});
const SurveyWithAnswerSchema = SurveySchema.and(z.object({
    answer: z.number(),
    langPairCode: language_codes_types_1.LanguagePairCodeSchema,
    userId: z.string(),
}));
const SurveyDataListSchema = SurveySchema.array();
const validateSurveyDataList = (x) => SurveyDataListSchema.safeParse(x);
exports.validateSurveyDataList = validateSurveyDataList;
//# sourceMappingURL=survey_types.js.map